import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Product } from "@dashboard/modules/products/types/products.types";
import { initialKitsState, KitsUiState } from "./kits.state";
import {
  Kit,
  KitDiscount,
  KitImageFormItem,
  KitProductFormItem,
} from "../types/kits.types";
import { DEFAULT_KIT_DISCOUNT_PERCENTAGE } from "../constants/kits.constants";

const kitsSlice = createSlice({
  name: "kits",
  initialState: initialKitsState,
  reducers: {
    setUi: (state, { payload }: PayloadAction<Partial<KitsUiState>>) => {
      state.ui = { ...state.ui, ...payload };
    },
    setKits: (state, { payload }: PayloadAction<Kit[]>) => {
      state.data.kits = payload;
    },
    upsertKit: (state, { payload }: PayloadAction<Kit>) => {
      const index = state.data.kits.findIndex((kit) => kit.id === payload.id);
      if (index >= 0) {
        state.data.kits[index] = payload;
      } else {
        state.data.kits = [payload, ...state.data.kits];
      }
    },
    removeKit: (state, { payload }: PayloadAction<string>) => {
      state.data.kits = state.data.kits.filter((kit) => kit.id !== payload);
    },
    setSelectedProducts: (state, { payload }: PayloadAction<Product[]>) => {
      state.data.selectedProducts = payload;
    },
    setFormProducts: (
      state,
      { payload }: PayloadAction<KitProductFormItem[]>
    ) => {
      state.data.formProducts = payload;
    },
    setFormImages: (state, { payload }: PayloadAction<KitImageFormItem[]>) => {
      state.data.formImages = payload;
    },
    setFormName: (state, { payload }: PayloadAction<string>) => {
      state.data.formName = payload;
    },
    setFormDiscount: (state, { payload }: PayloadAction<KitDiscount>) => {
      state.data.formDiscount = payload;
    },
    setEditingKitId: (state, { payload }: PayloadAction<string | null>) => {
      state.data.editingKitId = payload;
    },
    resetForm: (state) => {
      state.data.selectedProducts = [];
      state.data.formProducts = [];
      state.data.formImages = [];
      state.data.formName = "";
      state.data.formDiscount = {
        discountType: "percentage",
        discountValue: DEFAULT_KIT_DISCOUNT_PERCENTAGE,
      };
      state.data.editingKitId = null;
      state.ui.searchTerm = "";
      state.ui.selectedCategoryId = null;
      state.ui.showDeleteConfirmation = false;
      state.ui.saving = false;
    },
  },
});

export const kitsActions = kitsSlice.actions;
export default kitsSlice.reducer;
